export default __webpack_public_path__ + "static/media/clients.58afe83e.png";